import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Checkbox, FormControlLabel, CircularProgress, Typography, TextField } from '@mui/material';
import { ButtonSpinnerSlot } from '../ui/ButtonSpinner';
import axios from 'axios';

const CopyDialog = ({ open, onClose, courseId, courseName }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isMyselfChecked, setIsMyselfChecked] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [courseCount, setCourseCount] = useState(0);
  const [assessmentCount, setAssessmentCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [totalCourseCount, setTotalCourseCount] = useState(0); 
  const [totalAssessmentCount, setTotalAssessmentCount] = useState(0);
  const [totalStudentCount, setTotalStudentCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const userId=localStorage.getItem('userId1')
  const [copyToUserId, setCopyToUserId] = useState(userId);
const [disableAllCheckboxes, setDisableAllCheckboxes] = useState(true);
const [disableCourseAndAssessments, setDisableCourseAndAssessments] = useState(true);
const [disableCourseAndTrainings, setDisableCourseAndTrainings] = useState(true);
const [disableCourseTrainingsAndAssessments, setDisableCourseTrainingsAndAssessments] = useState(true);
const [disableCourseAndStudents, setDisableCourseAndStudents] = useState(true);
const [disableOnlyCourse, setDisableOnlyCourse] = useState(true);
const alertShownRef = useRef(false); 
const [alertMessage, setAlertMessage ] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  useEffect(() => {
    if (isMyselfChecked) {
      setCopyToUserId(userId);
      setSearchTerm("");
      setAlertMessage("");
      setSearchResults([]);
      setDisableAllCheckboxes(false);
      setDisableCourseAndAssessments(false);
      setDisableCourseAndStudents(false);
      setDisableOnlyCourse(false);
      setDisableCourseAndTrainings(false);
      setDisableCourseTrainingsAndAssessments(false)
    }
  }, [isMyselfChecked, userId]);

  useEffect(() => {
    if (searchTerm) {
      handleSearch();
    } else {
      setSearchResults([]);
    }
  }, [searchTerm]);

  const handleSearch = async () => {
    try {
      const callerId = localStorage.getItem('userId1') || localStorage.getItem('userId');
      const response = await axios.get(`${apiUrl}/api/users?search=${searchTerm}&userId=${callerId}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        },
      });
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error searching users:', error);
    }
  };

  const handleUserSelection = async (user) => {
    setLoading(true); // Set loading to true when a user is selected
    setCopyToUserId(user.userId);
    setSearchTerm(user.email);
    setAlertMessage("")
    await fetchData(user.userId);
    await fetchPackageDetails(user.userId);
    alertShownRef.current = false;
    setSearchResults([]);
    setLoading(false); // Set loading to false once the data fetching is complete
};

const triggerApiCall = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/course-summary`, {
      params: {
        courseId: courseId,
      },
      headers: {
        'Content-Type': "application/json",
        "Accept": "*/*",
        "Access-Control-Allow-Origin": "*",
        'Authorization': getBasicAuthHeader(), // Ensure this is set correctly
      },
    });

    if (response && response.data) {  // Ensure response and response.data exist
      //console.log(response.data);
      return response.data;  // Return the actual data from the response
    } else {
      throw new Error("No data in response");
    }
  } catch (error) {
    console.error("Error triggering API:", error);
    return null;  // Return null in case of error
  }
};



// Use useEffect to log the updated state values
useEffect(() => {
  if (totalCourseCount && totalAssessmentCount && totalStudentCount) {
    const newCourseDiff = totalCourseCount - courseCount;
    const newAssessmentDiff = totalAssessmentCount - assessmentCount;
    const newStudentDiff = totalStudentCount - studentCount;

    if (newCourseDiff >= 1) {
      triggerApiCall().then(response => {
        if (response) {
          const { testCount, studentCourseCount } = response;

          // Enable/Disable specific checkboxes based on conditions
          setDisableOnlyCourse(false);
          setDisableCourseAndTrainings(false);
          setDisableCourseAndAssessments(newAssessmentDiff < testCount);
          setDisableCourseTrainingsAndAssessments(newAssessmentDiff < testCount);
          setDisableCourseAndStudents(newStudentDiff < studentCourseCount);
          setDisableAllCheckboxes(newAssessmentDiff < testCount || newStudentDiff < studentCourseCount);
        } else {
          setDisableAllCheckboxes(true);
          setDisableCourseAndTrainings(true);
          setDisableCourseAndAssessments(true);
          setDisableCourseTrainingsAndAssessments(true);
          setDisableCourseAndStudents(true);
          setDisableOnlyCourse(true);
           if (response) {
          const { testCount, studentCourseCount } = response;

          // Enable/Disable specific checkboxes based on conditions
          setDisableOnlyCourse(false);
          setDisableCourseAndTrainings(false);
          setDisableCourseAndAssessments(newAssessmentDiff < testCount);
          setDisableCourseTrainingsAndAssessments(newAssessmentDiff < testCount)
          setDisableCourseAndStudents(newStudentDiff < studentCourseCount);
          setDisableAllCheckboxes(newAssessmentDiff < testCount || newStudentDiff < studentCourseCount);
        } else {
          setDisableAllCheckboxes(true);
          setDisableCourseAndTrainings(true);
          setDisableCourseAndAssessments(true);
          setDisableCourseTrainingsAndAssessments(true);
          setDisableCourseAndStudents(true);
          setDisableOnlyCourse(true);
          
        }
        }
      }).catch(error => {
        console.error("Error handling triggerApiCall:", error);
        setDisableAllCheckboxes(true);
        setDisableCourseAndTrainings(true);
        setDisableCourseAndAssessments(true);
        setDisableCourseTrainingsAndAssessments(true);
        setDisableCourseAndStudents(true);
        setDisableOnlyCourse(true);
        setAlertMessage("Error")
      });
    } else {
      setDisableAllCheckboxes(true);
      setDisableCourseAndTrainings(true);
      setDisableCourseAndAssessments(true);
      setDisableCourseTrainingsAndAssessments(true);
      setDisableCourseAndStudents(true);
      setDisableOnlyCourse(true);
      if (!alertShownRef.current) {
        setAlertMessage("Upgrade package to copy course");
        alertShownRef.current = true;
      }
    }
  }
}, [totalCourseCount, courseCount, totalAssessmentCount, assessmentCount, totalStudentCount, studentCount]);

useEffect(() => {
  // Update alert message based on checkbox states
  if (disableAllCheckboxes) {
    setAlertMessage("Upgrade package to copy course");
  }
   if (disableCourseAndAssessments) {
    setAlertMessage("Cannot copy Assessments as Instructor Package limit exceeds, upgrade package to copy assessments and enrollees.");
  }
   if (disableCourseAndStudents) {
    setAlertMessage("Cannot copy enrollees as Instructor Package limit exceeds, upgrade package to copy course and enrollees.");
  }
  if (disableOnlyCourse) {
    setAlertMessage("Course can't be copied as Instructor Package limit exceeds, upgrade package to copy course.");
  }
}, [disableAllCheckboxes, disableCourseAndAssessments, disableCourseAndStudents, disableOnlyCourse]); 


  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
  };

  const handleConfirm = async () => {
    if (!copyToUserId || !courseId || !selectedOption) {
      alert("Required fields missing");
      return;
    }

    setLoading1(true);

    try {
      const response = await axios.post(`${apiUrl}/api/clone`, null, {
        params: {
          courseId,
          userId: copyToUserId,
          selectedOption
        },
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          'Authorization': getBasicAuthHeader(),
        }
      });

      if (response.status === 200) {
        setSuccessMessage(`Copy of "${selectedOption}" is completed`);
      } else {
        console.error("Failed to copy:", response.data);
      }
    } catch (error) {
      console.error("Error during the copy API call:", error);
    } finally {
      setLoading1(false);
    }
  };
  

  async function fetchData(copyToUserId1) {
    try {
      const apiUrl1 = process.env.REACT_APP_API_URL1;
      const token = localStorage.getItem('token');
      const responseCourses = await axios.get(`${apiUrl}/api/course/${copyToUserId1}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        }
      });
      setCourseCount(responseCourses.data.length);

      const body = { user_id: copyToUserId1 };
      const responseAssessments = await axios.post(`${apiUrl1}/api/get_tests_for_instructor_id`, body, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': token,
          "X-Api-Version": 'v2'
        }
      });
      setAssessmentCount(responseAssessments.data.data.length);

      const responseStudents = await axios.get(`${apiUrl}/api/studentcourses/${copyToUserId1}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        }
      });
      setStudentCount(responseStudents.data.length);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const fetchPackageDetails = async (copyToUserId1) => {
    try {
      const responseUserPlan = await fetch(`${apiUrl}/api/userplans/${copyToUserId1}`, {
        method: 'GET',
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        },
      });

      const responseBody = await responseUserPlan.text();
      const data = JSON.parse(responseBody);

      if (data.planId) {
        const packageDetails = await getPackageDetails(data.planId);
        if (packageDetails) {
          const { numberOfCourses, numberOfStudents, numberOfAssessments } = extractPackageDetails(packageDetails);
          setTotalCourseCount(numberOfCourses);
          setTotalStudentCount(numberOfStudents);
          setTotalAssessmentCount(numberOfAssessments);
        } else {
          console.log('Package not found for the given plan ID');
        }
      } else {
        console.log('Plan ID not found in local storage');
      }
    } catch (error) {
      console.error('Error fetching package details:', error);
    }
  };

  const getPackageDetails = async (planId) => {
    try {
      const response = await axios.get(`${apiUrl}/api/packages/${planId}/${userId}`, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': getBasicAuthHeader(),
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching package details:', error);
      return null;
    }
  };

  const extractPackageDetails = (package1) => {
    if (package1) {
      const numberOfCourses = package1.courses;
      const numberOfStudents = package1.students;
      const numberOfAssessments = package1.assessments;

      return { numberOfCourses, numberOfStudents, numberOfAssessments };
    }
    return null;
  };

  const handleCloseSuccessMessage = () => {
    setSuccessMessage("");  
    onClose();              
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Copy Course</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={<Checkbox checked={isMyselfChecked} onChange={() => setIsMyselfChecked(!isMyselfChecked)} />}
          label="Myself"
          disabled={loading}
        />

        {!isMyselfChecked && (
          <>
            <TextField
              type="text"
              placeholder="Search…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              disabled={loading}
              fullWidth
              size="small"
              margin="dense"
            />
            {searchTerm && searchResults.length > 0 && (
              <ul>
                {searchResults.map((user) => (
                  <li key={user.userId} onClick={() => handleUserSelection(user)}>
                    {user.email}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}

        {loading && <CircularProgress />} {/* Show loading indicator */}

        <div>
        
        <FormControlLabel
  control={<Checkbox checked={selectedOption === "ALL"} onChange={() => handleCheckboxChange("ALL")} style={{
    color: disableAllCheckboxes ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="ALL"
  disabled={disableAllCheckboxes || loading}
  style={{
    color: disableAllCheckboxes ? 'lightcoral' : '#5b54e6',
  }}
/>
<FormControlLabel
  control={<Checkbox checked={selectedOption === "Only Course"} onChange={() => handleCheckboxChange("Only Course")} style={{
    color: disableOnlyCourse ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="Only Course"
  disabled={disableOnlyCourse || loading}
  style={{
    color: disableOnlyCourse ? 'lightcoral' : '#5b54e6',
  }}
/>
<FormControlLabel
  control={<Checkbox checked={selectedOption === "Course and Assessments"} onChange={() => handleCheckboxChange("Course and Assessments")} style={{
    color: disableCourseAndAssessments ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="Course and Assessments"
  disabled={disableCourseAndAssessments || loading}
  style={{
    color: disableCourseAndAssessments ? 'lightcoral' : '#5b54e6',
  }}
/>
<FormControlLabel
  control={<Checkbox checked={selectedOption === "Course and Trainings"} onChange={() => handleCheckboxChange("Course and Trainings")} style={{
    color: disableCourseAndTrainings ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="Course and Trainings"
  disabled={disableCourseAndTrainings || loading}
  style={{
    color: disableCourseAndTrainings ? 'lightcoral' : '#5b54e6',
  }}
/>
<FormControlLabel
  control={<Checkbox checked={selectedOption === "Course, Assessments and Trainings"} onChange={() => handleCheckboxChange("Course, Assessments and Trainings")} style={{
    color: disableCourseTrainingsAndAssessments ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="Course, Assessments and Trainings"
  disabled={disableCourseTrainingsAndAssessments || loading}
  style={{
    color: disableCourseTrainingsAndAssessments ? 'lightcoral' : '#5b54e6',
  }}
/>
<FormControlLabel
  control={<Checkbox checked={selectedOption === "Course and Enrollees"} onChange={() => handleCheckboxChange("Course and Enrollees")} style={{
    color: disableCourseAndStudents ? 'lightcoral' : '#5b54e6',
  }}/>}
  label="Course and Enrollees"
  disabled={disableCourseAndStudents || loading}
  style={{
    color: disableCourseAndStudents ? 'lightcoral' : '#5b54e6',
  }}
/>
{successMessage && (
      <Dialog open={Boolean(successMessage)} onClose={handleCloseSuccessMessage}>
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <Typography>{successMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessMessage} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    )}
{alertMessage && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {alertMessage}
          </Typography>
        )}

        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={handleConfirm} color="primary" disabled={loading || !copyToUserId || !courseId || !selectedOption}>
        {loading1 ? <ButtonSpinnerSlot size={24} /> : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyDialog;
